module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    ref: "toolbar",
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    ref: "editor",
    staticClass: "text"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58b210bc"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/wangEnduit.vue
// module id = 606
// module chunks = 70